export default [
    {
        path: "/contrato/:id",
        name: "contract-id",
        component: () => import("@/views/contract/Contract.vue"),
        meta: {
            pageTitle: "Contrato",
            breadcrumb: [
                {
                    text: "",
                },
            ],
            resource: "Contract",
            action: "read",
        },
    },
];
